/**
 * Query validation for GET /api/invites/inbox.
 *
 * @module schemas/invite-inbox
 */
import { z } from 'zod';
import { INVITE_INBOX_BUCKETS, INVITE_INBOX_PAGE_SIZE, INVITE_INBOX_SORT_DIRS, INVITE_INBOX_SORTS, INVITE_INBOX_TYPES, } from '../constants/invite-inbox';
export const InviteInboxBucketSchema = z.enum(INVITE_INBOX_BUCKETS);
export const InviteInboxSortSchema = z.enum(INVITE_INBOX_SORTS);
export const InviteInboxSortDirSchema = z.enum(INVITE_INBOX_SORT_DIRS);
const InviteInboxTypesCsvSchema = z
    .string()
    .optional()
    .transform((raw) => {
    if (!raw || raw.trim() === '')
        return [...INVITE_INBOX_TYPES];
    const parts = raw
        .split(',')
        .map((s) => s.trim())
        .filter((s) => INVITE_INBOX_TYPES.includes(s));
    return parts.length > 0 ? [...new Set(parts)] : [...INVITE_INBOX_TYPES];
});
export const ListInviteInboxQuerySchema = z.object({
    bucket: InviteInboxBucketSchema.default('pending'),
    sort: InviteInboxSortSchema.default('createdAt'),
    dir: InviteInboxSortDirSchema.default('desc'),
    limit: z.coerce.number().int().min(1).max(INVITE_INBOX_PAGE_SIZE).default(INVITE_INBOX_PAGE_SIZE),
    offset: z.coerce.number().int().min(0).default(0),
    types: InviteInboxTypesCsvSchema,
});
export function parseListInviteInboxQuery(params) {
    const parsed = ListInviteInboxQuerySchema.safeParse({
        ...(params.bucket ? { bucket: params.bucket } : {}),
        ...(params.sort ? { sort: params.sort } : {}),
        ...(params.dir ? { dir: params.dir } : {}),
        ...(params.limit ? { limit: params.limit } : {}),
        ...(params.offset != null && params.offset !== '' ? { offset: params.offset } : {}),
        ...(params.types ? { types: params.types } : {}),
    });
    return parsed.success ? parsed.data : null;
}
//# sourceMappingURL=invite-inbox.js.map